
import { defineComponent, onMounted } from 'vue';
import { AppCard, AppButton, AppSimpleTable } from '@/components';
import { usePicwordMapDetail } from '@/modules/picword/map/model/detail';
import { ROUTE_NAME_PICWORD } from '@/modules/picword/router';

export default defineComponent({
    name: ROUTE_NAME_PICWORD.MAP.DETAIL,
    components: { AppCard, AppButton, AppSimpleTable },
    setup() {
        const { model, fetch, actions } = usePicwordMapDetail();

        onMounted(async () => {
            await fetch();
        });

        return { model, actions, ROUTE_NAME_PICWORD };
    }
});
